const ActionType = (actionType) => `REMOTE_CONTROLLER_${actionType}`;

const ButtonActionType = (actionType) => ActionType(`BUTTON_${actionType}`);

export const BACK = ButtonActionType('BACK');
export const CHANNEL_DOWN = ButtonActionType('CHANNEL_DOWN');
export const CHANNEL_UP = ButtonActionType('CHANNEL_UP');
export const DPAD_DOWN = ButtonActionType('DPAD_DOWN');
export const DPAD_LEFT = ButtonActionType('DPAD_LEFT');
export const DPAD_RIGHT = ButtonActionType('DPAD_RIGHT');
export const DPAD_UP = ButtonActionType('DPAD_UP');
export const EXIT = ButtonActionType('EXIT');
export const GUIDE = ButtonActionType('GUIDE');
export const INFO = ButtonActionType('INFO');
export const OK = ButtonActionType('OK');
export const ESC = ButtonActionType('ESC');
export const TAB = ButtonActionType('TAB');
export const HOME = ButtonActionType('HOME');
export const END = ButtonActionType('END');
export const SPACE = ButtonActionType('SPACE');
export const CHARACTERS = ButtonActionType('CHARACTERS');
export const PREVIOUS_CHANNEL = ButtonActionType('PREVIOUS_CHANNEL');
export const TOGGLE_CLOSED_CAPTION = ButtonActionType('TOGGLE_CLOSED_CAPTION');
export const KEYBOARD_SPACE = ButtonActionType('KEYBOARD_SPACE');
